import "./brand-vehicle-tile.scss";
import React from "react";
import { Link } from "gatsby";
import { addSpaceInNumbers } from "../../utils";

const BrandVehicleTile = ({
	image,
	type,
	name,
	price,
	available,
	index,
	currency,
	askForPrice,
}) => {
	return (
		<div className="brand-vehicle-tile">
			<a href={`#${index}`}>
				<div className="brand-vehicle-tile__img-container">
					<img
						src={image}
						alt=""
						className="img-fluid brand-vehicle-tile__image"
					/>
				</div>
			</a>
			<div className="brand-vehicle-tile__type">
				{type[0] === "polintegra"
					? "półintegra"
					: type[0] === "integra"
					? "integra"
					: type[0] === "przyczepa"
					? "przyczepa"
					: type[0] === "alkowy"
					? "alkowa"
					: "kamper-van"}
			</div>
			<a href={`#${index}`}>
				<div className="brand-vehicle-tile__name">{name}</div>
			</a>
			<div className="brand-vehicle-tile__price">
				{askForPrice && askForPrice[0] === "true" ? (
					<a href="#dzial-sprzedazy">[?] zapytaj o cenę!</a>
				) : (
					`od ${addSpaceInNumbers(price)} ${currency}`
				)}
			</div>
			<div className="brand-vehicle-tile__buttons-container">
				<a
					href={`#${index}`}
					className="brand-vehicle-tile__producent-btn btn btn--rounded"
				>
					Sprawdź!
				</a>
				{available && (
					<span className="btn btn--available btn--no-hover">
						Dostępny <br /> od ręki!
					</span>
				)}
			</div>
		</div>
	);
};

export default BrandVehicleTile;
